// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2dTtN","productName":"Table_productName__33H1Q"};